import Immutable from 'immutable';

import {
	webapi,
	createModuleState,
	EntitySearchAndDetailModel,
	DefinitionUtils,
	EntityDetailModel,
	styled,
	FormDefinition as Form,
	FormItemDefinition as FormItem,
	CrossDefinition as Cross,
	CentererDefinition as Centerer,
	FormRepeaterDefinition as FormRepeater,
	MessageDefinition,
	ButtonDefinition as Button,
	ContextValidator,
	DateUtils,
	REPORTED_EXCEPTION,
	updateEntityTimestamp,
	ContainerDefinition as Container,
} from 'ps-gui';
import Message from '../blocks/message';

import {
	getColumnText,
	getPhrase
} from '../data/phrases';
import {
	createSearchModel,
	formatHtml
} from './utils';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('NotificationAdmin');

export default class NotificationAdminModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setInitialized() {
		return new NotificationAdminModel(this.#data.set('initialized', true));
	}

	initialize() {
		let srch = createSearchModel('/api/dq/sv_notification');
		return this.setEntitySearchAndDetail(
			new EntitySearchAndDetailModel()
				.setSearch(srch)
				.setDetail(getDetailModel())
				.setNewRowMode(EntitySearchAndDetailModel.NEW_ROW_MODE_LOAD_NULL_ID)
				.setEntityName('notification')
		).#setInitialized();
	}

	setEntitySearchAndDetail(model) {
		return new NotificationAdminModel(this.#data.set('esad', model.getState()));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}

function detailReadOnly(ctx) {
	return ctx.getProperty('isDeleted') === 'Y';
}

let detailDefinition = Centerer(Form().setOpacity(ctx => ctx.getProperty('isDeleted') === 'Y' ? '0.3' : '1').setVirtual(false).setBasePath('detail').setItems([
	Cross().setItems([
		FormItem('fromDate', 'date').setMandatory(true).setWithTime(true).setReadOnly(detailReadOnly),
		FormItem('toDate', 'date').setMandatory(true).setWithTime(true).setReadOnly(detailReadOnly),
		FormItem('notificationChannelId', 'lookup').setMandatory(true).setLookup('notificationChannel').setReadOnly(detailReadOnly).setLabel(ctx => getColumnText('notificationChannel')),
	]).setValidator(ContextValidator((errors, ctx, itemName) => {
		const fromDate = ctx.getProperty('fromDate');
		const toDate = ctx.getProperty('toDate');
		errors.add(
			ctx.getFullPath('toDate'),
			fromDate && toDate && DateUtils.compareDates(fromDate, toDate) >= 0 ? getPhrase('toDateMustBeGreaterThanFromDate') : null,
			'toDateLteFromDate'
		);
	})),
	MessageDefinition(() => {
		return (
			<HorGap></HorGap>
		);
	}),
	FormRepeater().setContentMargin('16px 0px').setNonDeletable(true).setContentHeader(ctx => ctx.getProperty('languageId')).setContent(
		Container([FormItem('text', 'text').setMandatory(true).setMultiline(true), MessageDefinition(ctx => {
			return (
				<Message maxWidth="570px" onCloseRequested={() => {}}>
					<span dangerouslySetInnerHTML={{__html: formatHtml(ctx.getProperty('text'))}}/>
				</Message>
			);
		})])
	).setPath(['text']),
	Cross().setItems([Button('delete', getPhrase('delete')).setListener(async e => {
		const ctx = e.ctx;
		let res = await webapi.execute('/api/proc/api_notification/deleteNotification', {
			id: ctx.getProperty('id')
		});
		if (res === REPORTED_EXCEPTION) {
			return;
		}
		updateEntityTimestamp('notification');
		ctx.setModel(await ctx.getModel().reload());
	})]).setJustifyContent('right').setVisible(ctx => ctx.getProperty('isDeleted') === 'N' && ctx.getProperty('id'))
])).setMaxWidth('800px');

const HorGap = styled.div`
	height: 16px;
`;

let detailModel = null;

export function getDetailModel() {
	if (!detailModel) {
		DefinitionUtils.setLabels(detailDefinition);

		detailModel = new EntityDetailModel()
			.setLoadUri('/api/proc/api_notification/getNotificationDetail')
			.setSaveUri('/api/proc/api_notification/saveNotification')
			.setDefinition(detailDefinition)
			.setEntityName('notification');
	}
	return detailModel;
}

